import DialogSection from "./DialogSection";

export default DialogSection;
